export default "__VITE_ASSET__CX360v1p__"